import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FormFieldsModule } from '@app/base-components';
import { I18nModule } from 'haba-core';
import { InvoiceDownloadComponent } from './invoice-download.component';

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    ReactiveFormsModule,
    FormFieldsModule,
    RouterModule.forChild([
      {
        path: 'rechnungskopie',
        component: InvoiceDownloadComponent,
      },
    ]),
    InvoiceDownloadComponent,
  ],
  exports: [InvoiceDownloadComponent],
})
export class InvoiceDownloadModule {}
